import React, { Component } from "react";
import { ROOT } from "../constants";
import "../css/checkout-result.css";
import i18n from "i18next";
import getCookie from "../function/getCookie";
import writeCookie from "../function/writeCookie";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import { Helmet } from "react-helmet";
//models
import {
  login,
  countryList,
  browsingHistory,
  cart,
  loginPopup,
  mobileMenu
} from "../models";
import urlReplace from "../function/replaceUrl";
import isUrlEn from "../function/isUrlEn";

class ResultFail extends Component {
  state = {
    lang: "zhTW"
  };

  async componentDidMount() {
    const url = window.location.pathname;

    /*先抓URL判斷語系*/
    isUrlEn(url);
    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系
    const {
      fetchCountryList,
      fetchUser,
      showLoginPopup,
      fetchCart,
      showMobileMenu,
      fetchMenuCountryList
    } = this.props;

    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }

    window.addEventListener("message", function (event) {
      if (event.data === "emphasisSuccess") {
        showLoginPopup(false); //登入成功後便關閉Popup畫面
        showMobileMenu(false); //登入成功後便關閉手機板Menu畫面
        fetchUser();
      }
      return;
    });

    fetchCountryList();
    fetchMenuCountryList();
    fetchUser();
    fetchCart();
  }

  handleClickLang(event) {
    const { fetchCountryList, fetchMenuCountryList } = this.props;

    if (event.target.value === "en") {
      i18n.changeLanguage("en");
      writeCookie("eshop-hk-language", "en");
      this.setState({
        lang: "en"
      });
      /*塞en回url字串*/
      urlReplace(window.location.pathname, "tc", "en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      writeCookie("eshop-hk-language", "zh_HK"); //香港網站
      this.setState({
        lang: "zhTW"
      });
      /*塞tc回url字串*/
      urlReplace(window.location.pathname, "en", "tc");
    }

    fetchCountryList(); //切換語系, 取得英文國家列表
    fetchMenuCountryList();
  }

  backHome = () => {
    const { lang } = this.state;
    window.location = `${lang === "zhTW" ? "/tc" : "/en"}/home`;
  };

  render() {
    const pathLang = this.state.lang === "en" ? "en" : "tc";
    const description =
      pathLang === "en"
        ? "At EMPHASIS, we embrace different styles and looks, resonating with the tastes of women from all walks of life. Our original designs are more than pretty accessories. They are designed to complete your look and express your individuality. We live in a world that imposes expectations on beauty. Our logo, featuring the stylised outline of an unconventional crown, is a proud symbol of our mission to challenge these expectations and let your inner strength shine through. Crown the Beautiful You."
        : "EMPHASIS 的原創珠寶不僅精緻瑰麗，我們獨特多變的設計更能圓滿妳的妝容服飾，展露自我風格。妳我縱使身處受標準審美限制的大時代，但我們品牌標誌上象徵富棱角的后冠能賦予妳勇於衝破枷鎖的力量，讓妳盡情綻放自己的獨特個性，閃爍耀眼。冠冕女性之美。";

    return (
      <>
        <Helmet>
          <title>EMPHASIS</title>
          <meta name="description" content={description} />
        </Helmet>
        <div id="header"></div>
        <div className="pageContent_wrap">
          <div className="content-wrapper-wider">
            <div className="breadcrumb_wrap d-none d-md-block">
              <a
                className="breadcrumb__link"
                href={this.state.lang === "en" ? "/en/home" : "/tc/home"}
              >
                <span>
                  <Translation>
                    {t => <>{t("resultFailPage.breadcrumbs.home")}</>}
                  </Translation>
                </span>
              </a>
              <a
                className="breadcrumb__link"
                href={`${ROOT}/${pathLang}/checkout`}
              >
                <span>
                  <Translation>
                    {t => <>{t("resultFailPage.breadcrumbs.myShoppingBag")}</>}
                  </Translation>
                </span>
              </a>
            </div>

            <div className="checkout_result_wrap checkout_result_fail_wrap chectout_sect">
              <p className="bigTitle" style={{ marginTop: "1em" }}>
                <Translation>
                  {t => <>{t("resultFailPage.paymentfail")}</>}
                </Translation>
              </p>

              <p className="desc">
                <Translation>
                  {t => <>{t("resultFailPage.notCompleted")}</>}
                </Translation>
                <Translation>
                  {t => (
                    <a
                      className="content-link"
                      href={`${ROOT}/${pathLang}/checkout`}
                    >
                      {t("resultFailPage.tryAgain")}
                    </a>
                  )}
                </Translation>
              </p>

              <p className="desc">
                <Translation>
                  {t => <>{t("resultFailPage.needAssistance")}</>}
                </Translation>
              </p>

              <p className="contact">
                <Translation>
                  {t => <>{t("resultFailPage.hotline")}</>}
                </Translation>
                ： <a href="tele:＋852 0000 0000">+852 2192 3228</a>
              </p>

              <p className="contact">
                <Translation>
                  {t => <>{t("resultFailPage.email")}</>}
                </Translation>
                ：
                <a className="text-gold" href="mailto:eshop@emphasis.com">
                  eshop@emphasis.com
                </a>
              </p>
            </div>
          </div>
        </div>
        <footer id="footer"></footer>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loadCustomerSuccessfully: state.customer.loadCustomerSuccessfully,
    customer: state.customer.customerData,
    isLogin: state.login.signed,
    isLoading: state.loading.isLoading
  };
};

const mapDispatchToProps = () => {
  return {
    fetchCart: () => cart.actions.fetchCart(),
    fetchCountryList: () => countryList.actions.fetchCountryList(),
    fetchMenuCountryList: () => countryList.actions.fetchMenuCountryList(),
    fetchUser: () => login.actions.fetchUser(),
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode),
    fetchBrowsingHistory: () => browsingHistory.actions.fetchBrowsingHistory(),
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool),
    showMobileMenu: bool => mobileMenu.actions.showMobileMenu(bool)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultFail);
